import { Directive, ElementRef, HostListener } from '@angular/core';

export const special: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'Delete',
'ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft'];

@Directive({
  selector: '[appNumberOnly]'
})

export class NumberOnlyDirective {
  private reqExp: RegExp = new RegExp('^[0-9.]*$');
  constructor(private ele: ElementRef) { }
  @HostListener('keydown', ['$event'])
  onkeydown(event: KeyboardEvent) {
    if (special.indexOf(event.key) !== -1) {
      return;
    }
    if (this.reqExp.test(event.key) === false) {
      event.preventDefault();
    }
  }
}